import request from '@/utils/request'
import requestNoToken from '@/utils/requestNoToken'
import Qs from 'qs'
export function queryCarByUserId(userId) {
  return request({
    url: '/index/queryCarByUserId',
    method: 'get',
    params: {userId}
  })
}
export function queryUserAddressList(userId) {
  return request({
    url: '/address/getUserAddressList',
    method: 'get',
    params: {userId}
  })
}
export function queryUserAddress(id) {
  return request({
    url: '/address/getUserAddress',
    method: 'get',
    params: {id}
  })
}

export function createAddress(data) {
  return request({
    url: '/address/create',
    method: 'post',
    data
  })
}

export function queryUserDeliverList(userId) {
  return request({
    url: '/address/getUserDeliverList',
    method: 'get',
    params: {userId}
  })
}



// WEBPACK FOOTER //
// ./src/api/checkOut.js